export default {
	empty: 'Please input',
	fuzhicg: 'Success',
	fuzhicc: 'Error',
	error:{
		notNull: 'Not be NULL',
		notYes: 'Non-compliant'
	},
  login: {
    signUp:'Daftar', 
    title: 'Dompet universal untuk semua aset digital anda.',
    submit: 'Log masuk',
    username: 'Sila masukkan nombor telefon anda',
    password: 'Sila masukkan kata laluan anda',
    verifycode:'Sila masukkan captcha',
    forget_password:'Terlupa kata laluan anda?',
	no_account:'Tidak mempunyai akaun AuWallet?',
    register:'Daftar',
    verifycode_tip:'sila masukkan captcha',
    verifycode_error:'Captcha tidak sah'
  },
  register:{
    title:'Daftar',
    username:'Nombor telefon',
    get_code:'Dapatkan kod',
    verifycode:'Kod pengesahan',
    password:'Kata laluan',
    repeat:'sahkan',
    invite_code:'Kod jemputan',
    submit:'Daftar',
    registered:'Sudah mendapat akaun',
    go_login:'Pergi Log Masuk'
  },
  nologin:{
    cloud_wallet:'Cloud Wallet',
    cloud1:'Perlindungan keselamatan teratas',
    cloud2:'Keuntungan aset yang unik, daftar dan deposit syiling untuk menikmati pendapatan',
    cloud3:'Menyokong lebih daripada 30+ syiling arus perdana dan 500+ token',
    button1:'Daftar',
    button2:'Log masuk',
    button_oauth: 'Log masuk dengan 2U.Chat',
    hd_wallet:'Dompet HD',
    hd1:'Kawalan 100% kunci persendirian, aset yang lebih terjamin',
    hd2:'Import satu klik perkataan mnemonik, mudah dan mudah digunakan',
    hd3:'Menyokong lebih daripada 30+ syiling arus perdana dan 500+ token',
    button3:'Daftar',
    button4:'Log masuk',
    doLogin:"Klik untuk masuk",
    welcomeTo:"Selamat datang di AuWallet",
  },
  forget:{
    title:'Lupa kata laluan?',
    phone_number:'Nombor telefon',
    verify_code:'Kod pengesahan',
    password:'Kata laluan',
    repeat:'Ulang sekali lagi',
    submit:'sahkan'
  },
  footer:{
    nav1:'dompet',
    nav2:'pasaran',
    nav3:'aset',
    nav4:'menemui',
    nav5:'saya'
  },
  home:{
    total:'Jumlah aset',
    invite:'Menjemput kawan-kawan',
    redbag:'Hantar Paket Merah',
    exchange:'Pertukaran',
    scan:'Imbas',
    address_book:'Buku alamat',
    notice:'Notis',
    setting:'Tetapan',
    view_mnemonic:'Lihat Mnemonik',
    backup_mnemonic:'Mnemonik Sandaran',
    create_wallet:'Buat Wallet',
    import_wallet:'Import Dompet', 
    welcome:'selamat datang',
	cant9sale: 'KYC must pass level 2 or above and have never participated in a 10% discount event.'
  },
  
  address:{
    new_address:'Alamat Baru',
    name:'nama',
    address:'Alamat',
    submit:'Buat',
	warning_msg: 'Perhatian: alamat ini hanya boleh menerima token erc20. Sila berhati-hati untuk tidak memilih saluran yang salah bila dipindahkan.'
  },
  swap:{
    title:'Tukar Kilat',
    pay:'Awak patut bayar',
    balance:'Baki yang ada',
    lock_rate:'Sila lengkapkan pembayaran dalam masa berikut untuk mengunci kadar pertukaran ini',
    gain:'Anda akan dapat',
    input:'Sila masukkan jumlah',
    tip:'Apabila mata wang yang anda dapat kosong, ini bermakna tiada mata wang untuk pertukaran kilat',
    submit:'Tukar Sekarang',
    choose_coin:'Pilih Syiling',
	notice_2ut: 'Saya telah membaca notis ini'
  },
  coin:{
    send:'Hantar',
    swap:'Tukar',
    receive:'terima',
    transactions:'Transaksi',
    type1:'Cloud Out',
    type2:'Cloud In',
    type3:'Tukar',
    type4:'kewangan',
    type7:'HD Keluar',
    type8:'HD Dalam',
    type9:'Hantar Paket Merah',
    type10:'Terima Paket Merah',
	type11:'AuWallet transfer out TimeEx',
	type12:'TimeEx transfer in AuWallet',
	type13: 'Chain shopping service fee',
	type14: '10% Off shopping service fee',
	type15: 'Withdrawal',
	type16: 'KYC Certification fees',
    flushing:'Membilas...',
    loading:'Memuatkan...',
    no_records:'Tiada rekod',
    wallet:' Dompet',
    tx_time:'Masa Transaksi',
    tx_id:'ID',
    tx_from:'daripada',
    tx_to:'Kepada',
    tx_memo:'Teguran',
    tx_status1:'gagal',
    tx_status2:'menunggu',
    tx_status3:'kejayaan',
    tx_status4:'yang belum selesai',

    receive_address:'Sila masukkan alamat terima',
    balance:'Seimbang',
    fee:'Bayaran',
    send_all:'Hantar Semua',
    gas_fee:'Bayaran gas',
    slow:'lambat',
    fast:'cepat',
    send:'Hantar',
    tx_password:'Sila masukkan kata laluan pembayaran',
    tx_remark:'Catatan (pilihan)',
    address_book1:'Buku Alamat Awan',
    address_book2:'Buku Alamat HD',
    need_pay_pass:'Sila tetapkan kata laluan pembayaran dahulu',
    need_pin:'Sila pergi ke pusat peribadi untuk menetapkan kod pin',

    
    set_receive_amount:'Tetapkan jumlah terima',
    receive_amount:'Terima jumlah',
    copy_receive_code:'Salin kod pembayaran',
    confirm:'sahkan',
    cancel:'Batal',
    rcv_address:'Alamat Penerimaan',
    search:'Masukkan kandungan carian',
    filter:'Penapis',
    remove:'Alih keluar',
    add:'Tambah',

    filter1:'Semua mata wang',
    filter2:'Ditambah',
    filter3:'Tidak Ditambah',
    
    notices:'Notis Dompet HD',
    notices2:'Notis Cloud Wallet',
	only_bitcoin: 'Hanya transaksi bitcoin di sini',
	only_eth: 'Hanya transaksi ETH di sini',
	only_usdt: 'Hanya transaksi ERC20 USDT di sini',
	only_2ut: 'Hanya transaksi 2UT di sini',
	only_u2u: 'Koin U2U sahaja',
	only_2u: 'Titik 2U sahaja',
	only_a2u: 'A2U sahaja',
	import: 'Import',
	info: 'Token overview'
  },

  market:{
    title:'Pasaran',
    coin:'aset',
    volume:'isipadu',
    price:'harga',
    change:'perubahan(24J)',
  },

  discover:{
    title:'Temui',
    popular:'Popular',
    all:'Semua'
  },

  my:{
    title:'saya',
    notice:'Notis',
    login:'Klik untuk log masuk ',
    welcome:'Selamat datang ke AuWallet',
    invite:'Ganjaran Jemputan',
    news:'Ekspres Harian',
    contact:'Khidmat Pelanggan',
    pin_on:'HIDUP',
    pin_off:'DIMATIKAN',
    default_currency:'Mata Wang Lalai',
    red_green:'Pilihan sebut harga',
    option1:'Hijau naik merah ke bawah',
    option2:'Merah atas hijau bawah',
    contract:'Perjanjian Perkhidmatan',
    privacy:'Dasar Privasi',
    help:'Pusat Bantuan',
	invite: 'My Invite code',
	onequan: 'My Business Circle',
	copy: 'Copy',
	total: 'Total',
	downloadapp: 'Download mobile APP.',
	download: 'Download',
	waiting: 'Waiting Or Use',
	reenxv: 'GreenX Vcode',
	greenxvet: 'Can use'
  },
  setup:{
    title:'Tetapan Dompet',
    pay_password:'Bayar Kata Laluan',
    on:'HIDUP',
    off:'DIMATIKAN',
    google:'Pengesahan Google',
    security_level:'Tahap keselamatan',
    account_name:'Nama akaun',
    logout:'Log keluar',
    register_time:'Masa Daftar',
    level:'tahap',
    modify_pay_password:'Ubah suai kata laluan bayar',
    reset_pay_password:'Tetapkan semula kata laluan bayar',
    reset_tip:'Untuk keselamatan akaun anda, sila masukkan kata laluan pembayaran asal untuk mengesahkan identiti anda',
    forget_pay_password:'Terlupa kata laluan bayar',
    set_pay_password:'Tetapkan kata laluan bayar',
    enter_password:'Sila masukkan kata laluan',
    enter_password2:'Sila masukkan semula',
    vcode:'Kod pengesahan',
    submit:'sahkan',
    pay_password_wrong:'Kata laluan yang anda masukkan salah',
    fontSize:'Ukuran huruf'

  },
  news:{
    title:'Ekspres Harian',
    share:'Kongsi',
    good:'Baik',
    bad:'teruk',
  },
 
  pin:{
    title:'Tetapkan kod PIN',
    desc1:'Untuk melindungi keselamatan aset anda, sila tetapkan kod PIN dahulu, kod PIN akan digunakan untuk membuka kunci dompet dan menghantar syiling',
    desc2:'Kod PIN adalah kata laluan tempatan, sila simpan dengan betul, jika ia hilang, ia tidak boleh dipulihkan',
    close:'Matikan kod PIN',
    title2:'Sahkan PIN',
    tip2_1:'Terlupa kod PIN anda? Selepas membuat sandaran dompet, pasang semula Apl dan tetapkan semula selepas mengimport frasa mnemonik'
  },
  google:{
    title:'Pengesahan Google',
    tip:'Pengesahan dua langkah Google boleh menambah lapisan perlindungan pada akaun anda. Apabila anda log masuk atau membuat transaksi, apabila anda memasukkan kata laluan anda, anda juga memerlukan kod pengesahan daripada pengesahan dua langkah',
    help:'Cara menggunakan pengesahan dua langkah Google',
  },
  security:{
    title:'Tahap keselamatan',
    title2:'Tahap keselamatan',
    tip:'Untuk keselamatan dana anda, anda memerlukan tetapan keselamatan lanjut dan maklumat nama sebenar sebelum anda boleh mengeluarkan syiling, dan had pengeluaran akan meningkat dengan sewajarnya',
    l3title:'Pilih jenis dokumen',
    l3tip:'Sila pilih negara yang mengeluarkan sijil anda',
    c1:'Amerika',
    c2:'Tanah Besar China',
    c3:'China Hong Kong, Macau dan Taiwan',
    c4:'Korea Selatan',
    c5:'Jepun',
    c6:'Singapura',
    c7:'Lain-lain',
    nousdt: 'Your USDT balance is less than 3 and cannot undergo KYC authentication.',
  },
  realname:{
    title:'Maklumat Pensijilan',
    tip:'AuWallet memerlukan anda menyerahkan ID foto yang dikeluarkan oleh kerajaan untuk lulus pengesahan keselamatan',
    subtitle1:'Borang Langganan Token 2U (2UT).',
    country:'Negara',
    country_hint:'Negara tempat tinggal anda',
    firstname:'Nama pertama',
    firstname_hint:'Nama pertama anda',
    surname:'Nama keluarga',
    surname_hint:'Nama keluarga anda',
    birthdate:'hari jadi',
    cert_id:'Nombor ID ',
    cert_id_hint:'Nombor ID anda',
    id_photo1:'Gambar depan ID',
    id_photo2:'Foto terbalik ID',
    address:'Alamat',
    address_hint:'Kediaman anda sekarang',
    addr_photo:'Bukti alamat',
    asset_photo:'Bukti aset',
    subtitle2:'Pensijilan kelayakan pelabur',
    tip1:'Saya mengesahkan bahawa saya memenuhi sekurang-kurangnya satu daripada kriteria berikut dan telah disahkan sebagai pelabur yang layak oleh pengeluar (jika berkenaan, lebih daripada satu boleh dipilih)',
    tip2:'Nota (1): Portfolio pelaburan merujuk kepada sekuriti dan tunai, tidak termasuk hartanah.',
    tip3:'Nota (2): Dokumen yang mempunyai penyata bulanan, ringkasan pengiraan, dsb. mesti dilampirkan dalam tempoh tiga bulan yang lalu',
    invest_exp:'Pengalaman pelaburan',
    other_exp:'Lain-lain',
    avg_volume:'Kelantangan',
    avg_volume_hint:'Purata volum urus niaga dalam 12 bulan lalu (USD)',
    avg_num:'Nombor',
    avg_num_hint:'Purata bilangan transaksi dalam tempoh 12 bulan yang lalu',
    exp_year:'Tahun pelaburan',
    exp_year_hint:'Berapa tahun pengalaman pelaburan',
    net_asset:'Aset Bersih',
    net_asset_hint:'Nilai Aset Bersih (USD)',
    risk_tolerance:'Toleransi risiko',
    invest_term:'Tempoh pelaburan yang ideal',
    derivative:'Derivatif',
    signature:'Tandatangan',
    reset:'Tetapkan semula',
    phone_number:'Nombor telefon',
    submit:'Hantar',
    option1_1:'Pelabur individu atau individu yang bernilai bersih tinggi dengan portfolio tunai dan/atau sekuriti tidak kurang daripada AS$20,000 (atau setara) dalam akaun bersama dengan pasangan atau anak mereka',
    option1_2:'Portfolio pelaburan syarikat atau perkongsian tidak kurang daripada AS$20,000 atau jumlah aset tidak kurang daripada AS$2 juta',
    option1_3:'Pelabur individu atau syarikat atau perkongsian bernilai tinggi bernilai tinggi membuka akaun dengan De La O RuralBank Inc. dan mempunyai tidak kurang daripada 20,000 USD pada masa menandatangani borang penilaian ini',
    option2_1:'Sekuriti',
    option2_2:'Niaga hadapan',
    option2_3:'Meletakkan',
    option2_4:'Lain-lain (sila nyatakan)',
    option3_1:'tinggi',
    option3_2:'Tengah',
    option3_3:'rendah',
    option4_1:'Lebih 3 tahun',
    option4_2:'1-3 tahun',
    option4_3:'Kurang dari 1 tahun',
    option5_1:'ya',
    option5_2:'Tidak'
  },
  envelope:{
    title:'Sampul surat merah',
    owned:'Sampul Saya',
    amount:'Jumlah',
    quantity:'Kuantiti',
    quantity_hint:'Kuantiti sampul surat',
    generate:'Menjana',
    title2:'Hantar Sampul',
    total:'Jumlah keseluruhan sampul merah',
    wishes:'Hajat',
    submit:'bayar',
    enter_pass:'Sila masukkan kata laluan bayar',
    choose_path:'Pilih kaedah penghantaran',
    view:'Lihat butiran sampul merah',
    choose_coin:'Pilih syiling',
    need_pay_password:'Sila tetapkan kata laluan bayar dahulu',
    share:'Kongsi sampul merah itu dengan rakan anda',
    title3:'Rekod Sampul Merah',
    num:'Kuantiti',
  },
  mnemonic:{
    title:'Mnemonik Dompet Sandaran',
    tip:'Mnemonik ialah kunci peribadi, yang merupakan kunci untuk mengawal harta anda',
    tip1:'1. Ia mengandungi 12 aksara, sila salin dan simpan di tempat yang selamat.',
    tip2:'2. 100% akan disimpan oleh anda, sekali hilang, ia tidak boleh diambil semula.',
    tip3:'3. Sila pastikan anda melengkapkan sandaran frasa mnemonik sebelum menerima mata wang atau menyahpasangnya.',
    backup:'Sandarkan sekarang',
    later:'Buat nanti',
    tip4:'Sila lihat sekeliling',
    tip5:'Sesiapa yang mendapat mnemonik bermakna mereka telah mendapat aset anda. Sila pastikan tiada sesiapa di sekeliling dan tiada kamera.',
    understand:'Faham',     
    title2:'Lihat Mnemonik',
    tip6:'Anda boleh mengimport frasa mnemonik untuk dipasangkan pada peranti lain, atau gunakan dompet AuWallet pada peranti lain untuk mengimbas kod QR untuk digandingkan.',
    tip7:'Tolong jangan ambil tangkapan skrin! Jika seseorang mendapat frasa mnemonik anda, mereka akan mendapat aset anda secara langsung!',
    view_code:'Lihat kod QR yang disulitkan',
    tip8:'Menyulitkan kod QR adalah untuk memudahkan dompet dipasangkan dengan peranti baharu. Tolong jangan ambil tangkapan skrin dan simpannya, dan pastikan tiada orang lain di sekeliling atau kamera tersembunyi.',
    tip9:'Kod QR ini hanya boleh digunakan oleh dompet AU. Semasa mengimbas, anda perlu memasukkan kod PIN APP semasa dalam APP untuk diimport untuk berjaya mengimport mnemonik yang sepadan.',

    title3:'Sila salin mnemonik AuWallet',
    tip3_1:'Frasa mnemonik AuWallet digunakan untuk memulihkan dompet. Sila salin 12 perkataan berikut di atas kertas mengikut susunan dan simpan di tempat yang selamat.',
    tip3_2:'Tolong jangan ambil tangkapan skrin! Jika seseorang mendapat frasa mnemonik anda, mereka akan mendapat aset anda secara langsung!',
    save:'Saya telah menyimpannya dengan selamat',

    title4:'Sila sahkan frasa mnemonik AuWallet',
    tip4_1:'Untuk memastikan anda telah menyalin perkataan mnemonik AuWallet dengan betul, sila pilih perkataan yang sepadan dengan nombor siri.',
    finish:'Selesai',
    next:'Seterusnya',
    verror:'Ralat pengesahan',

    title5:'Pulihkan Dompet Mnemonik',
    tip5_1:'Sila masukkan perkataan mnemonik dalam borang di bawah untuk membalas dompet. Selepas setiap perkataan mnemonik dimasukkan, tekan kekunci "ruang" untuk melompat ke perkataan seterusnya',
    recover:'Mulakan pemulihan',
    ask:'Gantikan dompet semasa?',
    tip5_2:"Mengimport dompet akan menimpa dompet semasa. Jika anda belum membuat sandaran lagi, dompet semasa akan hilang selama-lamanya.",
    tip5_3:'Saya telah menyandarkan dompet semasa saya dan bersetuju untuk menulis ganti',
    cancel:'Batal',
    import:'Teruskan mengimport',
    agree:'Sila pilih untuk bersetuju',
    create_success:'Berjaya dibuat',
    complete:'Sila isikan mnemonik yang lengkap',
  },
  invite:{
    title:'Jemputan Saya',
    total:'Nombor jemputan',
    invite_num:'Bilangan rakan berdaftar',
    bonus1:'Kawan 1 peringkat',
    every:'bagi setiap orang',
    bonus2:'Kawan 2 tingkat',
    bonus3:'Kawan 3 tingkat',
    deposit:'Bilangan rakan yang mendepositkan syiling',
    list:'Senarai jemputan',
    subtitle1:'Pendaftaran',
    subtitle2:'Deposit',
    no_records:'Belum ada jemputan'
  },
  lang:{
    set_lang:'Tetapkan bahasa',

  },
  setting:{
    tip:"Sistem ini sebenarnya berdagang dalam dolar A.S., dan sistem secara automatik menukar harga komisen pengguna kepada dolar A.S. pada kadar pertukaran terkini. Harga komisen sebenar mungkin berbeza sedikit daripada harga input pengguna"
  },
  send:{
    title:'Jenis Pemindahan',
    t1:'Pemindahan Blockchain',
    t2:'Pemindahan Dalaman',
  },
  sortable:{
    title:'Isih Tersuai',
    drag_to_sort:'Seret untuk mengisih',
    currency:'mata wang'
  },
  system:{
    flushing:'Membilas...',
    loading:'Memuatkan...',
    btn1:'sahkan',
    btn2:'Batal',
    add:'Tambah',
    search:'Cari',
    topPullText:'Tarik ke bawah untuk menyegarkan',
    topDropText:'Lepaskan muat semula',
    topLoadingText:'Memuatkan...',
    copy_succ:'Berjaya menyalin',
    copy_fail:'Salinan gagal',
    about:'About'
  },
  share:{
    title:'Kongsi',
    download:'Imbas kod untuk memuat turun AuWallet',
    sharecode:'Kod jemputan (klik untuk menyalin):',
    view_invites:'Lihat butiran jemputan',
    copy_link:'Salin pautan',
      attention:'Salin pautan di atas, tampalkannya ke dalam penyemak imbas mudah alih anda dan bukanya untuk memuat turun dompet Au.'
  },
  wealth:{
    tit:"Aset",
    title:'Kekayaan Saya',
    title1:'Perlombongan',
    title2:'Pelan Syiling',
    hot:'Cadangan popular',
    plan1:'Pelan ondemand',
    plan2:'Pelan tetap',
    annu_return:'pulangan tahunan',
    in_amount:'jumlah dalam',
    transfer_all:'semua',
    view_rules:'peraturan lihat',
    pay_password:'Sila masukkan kata laluan pembayaran',
    asset:'Kekayaan',
    search:'Siasatan transaksi',
    rules:'peraturan',
    order_time:'masa pesanan',
    value_date:'tarikh nilai',
    expiry_date:'tarikh luput',
    highlights:'sorotan',
    remaining_quota:'baki kuota',
    buy:'Beli sekarang',
    ystday_earnings:"pendapatan semalam",
    total_earnings:'jumlah pendapatan',
    transfer_in:'dalam',
    transfer_out:'keluar',
	transfer_outed:'Ditebak',
    tran_all:'semua',
    tran_in:'dalam',
    tran_out:'keluar',
    tran_earning:'memperoleh pendapatan',
    prod_all:'semua',
    prod1:'Perlombongan PoS',
    prod2:'Pelan Syiling',
    curr_all:'semua',
    out_amount_tip:'Sila masukkan amaun pindahan',
    send:'Hantar',
    success:'kejayaan',
    amount_tip:'Sila masukkan amaun',
  },
  ads:{
    title:'berita baik',
    content:'U2U sedang hangat dibeli',
    content2:'2UT sedang hangat dibeli',
    buy:'beli',
    plan_name:'U2U Isu Baharu',
    tip: 'U2U is 10% off!'
  },
  buyuut: {
    maxtip: 'Each person can buy a maximum of 100',
    current: 'Current',
    price: 'Price',
    discount: 'Discount',
    off: 'OFF',
    amountlabel: 'Purchase quantity',
    maxerror: 'You can\'t buy more than 100',
    totalprice: 'Total Price',
    balance: 'Balance',
    purchase: 'Purchase',
    rulestitle: 'Rules of Activity'
  },
  receive:{
	  fuzhicg:'Salin berjaya.',
	  fuzhicc:'Salin gagal.',
  },
  alert:{
  	  cancel:'batalkan',
  	  confirm:'sahkan'
  },
  against:{
		  no100: 'Usdt mesti berbilang dari 100'
	},
	package:{
		  title: 'Pakej',
		  amount: 'Jumlah',
		  time: 'Masa',
		  coin: 'Token',
		  price: 'Harga',
		  scale: 'Scale',
		  quantity: 'Kuantiti',
		  submit: 'Hantar',
		  total: 'Jumlah',
		  points: 'Titik',
		  balance: 'Imbangan',
		  apoints: 'Titik Tersedia:',
		  apoints2: 'Penghasilan harta yang tersedia',
		  abalance: 'Imbangan tersedia(USDT):',
		  abalance2: 'Imbangan tersedia(U2U):',
		  import: 'Import',
		  orders: 'Perintah',
		  orders_detail: 'Perincian perintah',
		  defi: 'DEFI',
		  nopoint: 'Buang semula lebih dari titik yang tersedia',
		  nobalance: 'Pemulihan melebihi keseimbangan yang tersedia',
		  nologin: 'Login telah tamat, sila log masuk lagi.',
		  pay_type: 'Jenis bayaran'
	},
	nasdaq:{
		  label :'(IPO)Stock pre purchase application',
		  label2 :'Number of (IPO)stock exchange applications',
		  apply :'Apply',
		  applyed :'Applied',
		  background :'Background Description',
		  text :'1. The formal plan must meet the requirements that the NASDAQ stock reform documents submitted by (relevant stocks) are received and entered into the countdown process for submission.<br />2. During the official review process of NASDAQ (related stocks), there is no rule out the possibility of rejection or extension of time.',
		  cancel: 'Cancel',
		  submit: 'Submit',
	},
	ysjjy: "(Based on actual transactions)"
}
